import Vue from 'vue'
import Vuex from 'vuex'
import * as user from '@/store/modules/user.js'
import * as patient from '@/store/modules/patient.js'
import * as manufacturer from '@/store/modules/manufacturer.js'
import * as product from '@/store/modules/product.js'
import * as pods from '@/store/modules/pods.js'
import * as notification from '@/store/modules/notification.js'
import * as locale from '@/store/modules/locale.js'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    patient,
    manufacturer,
    product,
    pods,
    notification,
    locale
  },
  state: {
    connected: navigator.onLine
  },
  mutations: {
    SET_CONNECTED(state, payload) {
      state.connected = payload
    }
  },
  actions: {
    SetConnected({ commit }, payload) {
      commit('SET_CONNECTED', payload)
    }
  },
  getters: {
    connected: state => state.connected
  }
})
